import React from 'react'

  import {Link, NavLink} from 'react-router-dom'
import styled from 'styled-components'
 

const WEBHEADER = styled.header`
@media screen and (max-width: 48rem) {
    display: none;
}

`

const MOBILE = styled.nav`
z-index: 25;
ul li:first-child {
font-family: Roboto;
font-style: normal;
font-weight: 900;
font-size: 35px;
line-height: 56px; 

@media screen and (max-width: 48rem) {
    margin-left: auto;   
}

color: #261431;
}
li {
    list-style-type: none;
}

a {
    text-decoration: none;
}

button.btn-app-header {
     display: inline-block;
       background: #FFFFFF;
border: 2px solid rgba(38, 20, 49, 0.97);
box-sizing: border-box;
border-radius: 5px;
     transition: all .5s ease-in-out;
    font-size: 18px;
    cursor: pointer;
    text-align: center;
      padding: .5rem;
    color: rgb(38, 20, 49);
    width: 260px;
    height: 48px;  
      font-size: small;
    &:hover {
        color: white;
        background: rgba(38, 20, 49, 0.97);
    }
}
    position: fixed;
     width: 100vw;
     .container-list {
        display: flex;
        margin: 0;
        width: 100%;
        background-color: white;
        height: 5.5rem;
        align-items: center;
        justify-content: space-between;
        padding: 2rem 5rem;

        ul {
            @media screen and (max-width: 48rem) {
                display: none;
            }
            width: 40rem;
            display: flex;
            justify-content: space-between;
            align-items: center;
            a {
                color: rgb(38, 20, 49);
                font-weight: 600;
                font-size: small;

                &:hover {
                    color: #1d458a;
                }
            }
            
        }
`



const NavBar = ({loginBtn}) => {
    
    //   const handleLogOut = async () => {
    //      const api = ` https://iamwealthy.herokuapp.com/logout/${sessionStorage.getItem('mail')}`

    //     let res = fetch(api)

    //     let {log} = await (await res).json()
        
    //     if(log === 'failed') {
    //           alert('unable to log out, it seems an error occured, pls try again')
    //     }  
    //     else {
    //        await sessionStorage.removeItem('lStr')
    //     //    sessionStorage.removeItem('mail')
    //        window.location.replace('/')
 

    //     }
    // }


    return ( 
        <>
        
       <WEBHEADER>

           
<MOBILE>

<ul class="container-list">
        <li id="dashH">
            Iamwealthy  
        </li>
    
         <ul>

           <li> <Link to='/about'>About </Link> </li>  

           <li> <NavLink to='/help-center'> Help center </NavLink> </li>  

           <li> <Link to='/faqs'>FAQ's </Link> </li> 

           
           <li> <Link to='/Iamwealthy-login'>
        
          <button style={loginBtn === true ? {display: 'none'} : {display: 'inline-block'} } class="btn-app-header">
             Login
         </button>
                </Link> 
            </li> 
           

          </ul>
            </ul>

</MOBILE>

       </WEBHEADER>

        </>
     );
}

NavBar.defaultProps = {
    loginBtn: true
}
 
 
export default NavBar;